import { graphql } from "~/gql";

export const ALL_FEE_EARNERS = graphql(/* GraphQL */ `
  query AllFeeEarners {
    allFeeEarners {
      ...FeeEarnerParts
    }
  }
`);
